import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from 'app/services/data.service';

@Pipe({
  name: 'formatPtoventa'
})
export class FormatPtoventaPipe implements PipeTransform {

  constructor(private dataService: DataService) {}

  transform(value: string | number | null | undefined, ...args: unknown[]): string {
     if (value === null || value === undefined) {
       return '';
     }
     return this.dataService.formatearPuntoVenta(value);
  }

}
